import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Row, CardImg, Modal, ModalHeader, ModalBody } from 'reactstrap';

import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { dAPI_Delete_Ingetration, API_CloudBeds_Connection } from '../../../../../constants/APIs';
import CloudsBedsIntegration from './CloudsBedsIntegration';
import CloudBeds_Logo from './../images/cloudBeds_logo.png';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Changecloudbeds } from '../../../../../redux/actions';
function CloudsBedsIntegrationThumb({ integration,Changecloudbeds, allProperties, LoadIntegrations }) {

    const [deleteVisible, setDeleteVisible] = useState(false);
    const [disconnectVisible, setDisconnectVisible] = useState(false);
    const [formatedProperties, setFormatedProperties] = useState('');
    const [moreProperties, setMoreProperties] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        try{
        const result = integration.properties.map(id => {
            return allProperties.find(elem => elem.id === id);
        });
        if (result.length > 2) {
            const filterResults = result.slice(0, 2);
            setFormatedProperties(filterResults.map(elem => elem.name).join(", "));
            setMoreProperties('and ' + (result.length - filterResults.length) + ' more')
        }
        else {
            const filterResults = result.filter(elem => elem !== undefined);
            setFormatedProperties(filterResults.map(elem => elem.name).join(", "));

        }
    }catch{}
    }, [integration, allProperties]);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        Changecloudbeds('');
        AxiosAPI({
            method: 'Post',
            url: `${API_CloudBeds_Connection}/disconnect?iid=${integration.id}&group_id=${getGroupID()}`,
        }).then(res => {
            //toggle();            
        });
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
        }).then(res => {
            toggle();
            LoadIntegrations();
            Changecloudbeds('');
        });
    };
    const handleDisconnect = () => {
        setDisconnectVisible(!disconnectVisible);
        Changecloudbeds('');
        AxiosAPI({
            method: 'Post',
            url: `${API_CloudBeds_Connection}/disconnect?iid=${integration.id}&group_id=${getGroupID()}`,
        }).then(res => {
            Changecloudbeds(''); 
            LoadIntegrations();       
        });
        setTimeout(()=>{
            LoadIntegrations(); 
        },2000);        
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    const generateDisconnectButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={disconnectVisible} toggle={()=>setDisconnectVisible(!setDisconnectVisible)}>
                                <ModalHeader toggle={()=>setDisconnectVisible(!setDisconnectVisible)}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be disconnected!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDisconnect()}
                                        size="xs"
                                    >
                                        Disconnect
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={()=>setDisconnectVisible(!setDisconnectVisible)}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleConnect=()=>{
        Changecloudbeds(integration.id);
        window.location.href = `https://hotels.cloudbeds.com/api/v1.1/oauth?client_id=${integration.channelDetails.clientId}&redirect_uri=${process.env.REACT_APP_CLOUDBEDS_REDIRECT_URL}&response_type=code&scope=read%3AcustomFields+write%3AcustomFields+read%3Apayment+write%3Apayment+read%3Areservation+write%3Areservation+read%3Ahotel`;
    };
    return (
        <Fragment>
            {integration ? <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card className="d-flex flex-row" style={{ height: '215px' }}>
                
              <h3 className="integrationChannel stripe-logo"> <img
                    src={CloudBeds_Logo}
                    alt="Logo"
                    style={{ maxWidth: '100px' }}
                  /></h3>
                    <a href="#/" className="integrationremove"
                        onClick={toggle}
                    >
                        {" "}
                        <h3 className="iconsminds-remove" />{" "}
                    </a>

                    <CardBody>
                        <Row className="mt-3">                        
                            <Colxx xxs="12" className="mb-2 text-center">                                 
                                    <div className="mb-1">
                                        <p><b>Name</b></p>
                                        {integration.name}
                                    </div>
                                    </Colxx>                               
                                    <Colxx xxs="12" className="mb-0 text-center">                              
                                    <div className="mb-2">
                                        <p><b>Business Name</b></p>
                                        <b>{formatedProperties} </b>
                                        <b>{moreProperties}</b>
                                    </div>
                                    </Colxx>                              
                                    <Colxx xxs="6" className="mb-1 text-center">
                                    <Button
                                        className="ml-2"
                                        size="xs"
                                        color="success"
                                        outline
                                        style={{ marginTop: '20px', display: 'inline-block' }}
                                        onClick={() => setIsEditing(!isEditing)}
                                    >
                                        Edit
                                    </Button>
                                
                            </Colxx>

                            {integration.channelDetails.hotelId ===''?
                             <Colxx xxs="3" className="mb-1 text-center">
                             <Button
                                 className="ml-2"
                                 size="xs"
                                 color="success"
                                 outline
                                 style={{ marginTop: '20px', display: 'inline-block' }}
                                 onClick={() => handleConnect()}
                             >
                                 Connect
                             </Button>
                            </Colxx>:
                            <Colxx xxs="6" className="mb-1 text-center">
                                    <Button
                                        className="ml-2"
                                        size="xs"
                                        color="danger"
                                        outline
                                        style={{ marginTop: '20px', display: 'inline-block' }}
                                        onClick={() => setDisconnectVisible(!disconnectVisible)}
                                    >
                                        Disconnect
                                    </Button>
                            </Colxx>}
                            
                        </Row>
                    </CardBody>
                </Card>
            </Colxx> : null}
            {isEditing ? (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12">
                                <CloudsBedsIntegration
                                    visible={isEditing}
                                    allProperties={allProperties}
                                    LoadIntegrations={LoadIntegrations}                                                                                                            
                                    toggle={() => {
                                        setIsEditing(!isEditing);
                                    }}
                                    id={integration.id}
                                />
                            </Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                        </Row>
                    </Colxx>
                </Row>
            ) : null}
            {generateDeleteButton()}
            {generateDisconnectButton()}
        </Fragment>
    );
}

const mapStateToProps = ({ }) => {
};
export default injectIntl(connect(mapStateToProps, {Changecloudbeds} )(CloudsBedsIntegrationThumb));